export default {
  testimonial: {
    subtitle: "Testimonials",

    title1: "Trusted by",
    title2: "Restaurants & Businesses",

    review:
      "MAHAL has transformed the way we source food supplies. Transparent pricing and reliable delivery make operations smooth.",

    role: "Business Customer",
  },
};